module.exports = __webpack_public_path__ + "img/file-slides.17b66a29.svg";